import type { Rarity } from "@/domain/gems-game/domain/lib/Earning";
import { RARITY_COLOR } from "@/utils/rewards";
import { RARITY_GRADIENT_MAP } from "@/utils/rewards";
import { onDarkBase } from "@biom3/design-tokens";
import KeyRoundedIcon from "@mui/icons-material/KeyRounded";
import { Avatar } from "@mui/material";

interface RarityKeyIconProps {
  rarity: Rarity;
  size?: number;
}

export const RarityKeyIcon = ({ rarity, size = 32 }: RarityKeyIconProps) => {
  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        p: "2px",
        background: RARITY_GRADIENT_MAP[rarity],
      }}
      variant="circular"
    >
      <Avatar
        sx={{
          width: "100%",
          height: "100%",
          backgroundColor: onDarkBase.color.neutral[600],
        }}
        variant="circular"
      >
        <KeyRoundedIcon
          sx={{ fontSize: size * 0.5, color: RARITY_COLOR[rarity] }}
        />
      </Avatar>
    </Avatar>
  );
};
